<template>
  <div id="DaTeacher">
    <div ref="getTeacherView" style="height:400px"></div>


    <div ref="getEducation" style="height:400px;"></div>

    <div ref="getTitles" style="height:400px;"></div>


    <div ref="getTeacherDiscipline" style="height:400px;"></div>


    <div ref="getAge" style="height:400px;"></div>

  </div>
</template>

<script>
export default {
  data() {
    return {
        apiPath: '/api/Teacher/',


        chartGetTeacherView: null,
        chartGetEducation: null,
        chartGetTitles: null,
        chartGetTeacherDiscipline: null,
        chartGetAge: null,

    };
  },
  components: {},
  created: function() {
    
  },
  mounted: function() {

        this.GetTeacherView();
        this.GetEducation();
        this.GetTitles();
        this.GetTeacherDiscipline();
        this.GetAge();



        window.onresize = function () {
            this.chartGetTeacherView.resize();
            this.chartGetEducation.resize();
            this.chartGetTitles.resize();
            this.chartGetTeacherDiscipline.resize();
            this.chartGetAge.resize();
        };

  },
  methods: {

        //教师概览--饼状图
        async GetTeacherView () {
            this.chartGetTeacherView = this.echarts.init(this.$refs.getTeacherView);

            let option = {
                title: {
                    text: "教师数:0人",
                    textStyle: {
                        color: '#95C5E4'
                    },
                    x: 'center',
                    y: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    x: 'right',
                    data: ""
                },
                series: [
                    {
                        name: '人数',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: []
                    }
                ]
            };

            this.chartGetTeacherView.setOption(option);
            this.chartGetTeacherView.showLoading();

            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetTeacherView'
            );
            console.log(res)
            if (res&&res.success) {
                let totalCount = 0;
                let seriesDataList = [];
                res.data.Data.forEach( (item)=> { 
                    totalCount += item.Count;
                    seriesDataList.push({ value: item.Count, name: item.SexName });
                })
                option.title.text = "教师数:" + totalCount + "人";
                option.series[0].data = seriesDataList;
                this.chartGetTeacherView.hideLoading();
                this.chartGetTeacherView.setOption(option, true);


            } else {
              this.xy.msgError(res.msg);
                // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
            }
                


        },

        //学历分布--雷达图
        async GetEducation () {
            this.chartGetEducation = this.echarts.init(this.$refs.getEducation);
            let option = {
                title: {
                    text: '学历分布'
                },
                tooltip: {},
                legend: {
                    //show:false,
                    //data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
                },
                radar: {
                    // shape: 'circle',
                    radius: '70%',
                    name: {
                        textStyle: {
                            color: '#fff',
                            backgroundColor: '#999',
                            borderRadius: 3,
                            padding: [3, 5]
                        }
                    },
                    indicator: [
                       //{ name: '销售（sales）' },
                       //{ name: '管理（Administration）' },
                       //{ name: '信息技术（Information Techology）' },
                       //{ name: '客服（Customer Support）' },
                       //{ name: '研发（Development）' },
                       //{ name: '市场（Marketing）' }
                    ]
                },
                series: [{
                    name: '',
                    type: 'radar',
                    data: [
                        {
                            value: [],//[4300, 10000, 28000, 35000, 50000, 19000],
                            name: '学历分布'
                        },
                    ]
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            //this.chartGetEducation.setOption(option);
            this.chartGetEducation.showLoading();
            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetEducation'
            );
            console.log(res,'-----------res')
            if (res&&res.success) {
                let maxVal = 0;
                let radarIndicatorArr = [];
                let seriesDataList = [];
                res.data.forEach( (item)=> {
                    seriesDataList.push(item.Count);
                    if (maxVal <= item.Count) {
                        maxVal = item.Count;
                    }
                });

                res.data.forEach( (item)=> {
                    radarIndicatorArr.push({ name: item.EducationName, max: maxVal });
                });
                
                this.chartGetEducation.hideLoading();
                if(seriesDataList.length!==0&&radarIndicatorArr!==0){
                  option.radar.indicator = radarIndicatorArr;
                  option.series[0].data[0].value = seriesDataList;
                  this.chartGetEducation.setOption(option, true);
                }
                

            } else {
              this.xy.msgError(res.msg);
                // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
            }
        },

        //职称分布--雷达图
        async GetTitles () {
            this.chartGetTitles = this.echarts.init(this.$refs.getTitles);
            let option = {
                title: {
                    text: '职称分布'
                },
                tooltip: {},
                legend: {
                    //show:false,
                    //data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
                },
                radar: {
                    radius: '70%',
                    // shape: 'circle',
                    name: {
                        textStyle: {
                            color: '#fff',
                            backgroundColor: '#999',
                            borderRadius: 3,
                            padding: [3, 5]
                        }
                    },
                    indicator: [
                       //{ name: '销售（sales）' },
                       //{ name: '管理（Administration）' },
                       //{ name: '信息技术（Information Techology）' },
                       //{ name: '客服（Customer Support）' },
                       //{ name: '研发（Development）' },
                       //{ name: '市场（Marketing）' }
                    ]
                },
                series: [{
                    name: '',
                    type: 'radar',
                    data: [
                        {
                            value: [],//[4300, 10000, 28000, 35000, 50000, 19000],
                            name: '职称分布'
                        },
                    ]
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            //this.chartGetTitles.setOption(option);
            this.chartGetTitles.showLoading();

            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetTitles'
            );
            if (res&&res.success) {

                let maxVal = 0;
                let radarIndicatorArr = [];
                let seriesDataList = [];
                res.data.forEach( (item)=> {
                    seriesDataList.push(item.Count);
                    if (maxVal <= item.Count) {
                        maxVal = item.Count;
                    }
                });

                res.data.forEach( (item)=> {
                    radarIndicatorArr.push({ name: item.TitlesName, max: maxVal });
                });

                option.radar.indicator = radarIndicatorArr;
                option.series[0].data[0].value = seriesDataList;

                this.chartGetTitles.hideLoading();
                if(radarIndicatorArr.length!==0&&seriesDataList.length!==0){
                  this.chartGetTitles.setOption(option, true);
                }
                
            } else {
              this.xy.msgError(res.msg);
                // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
            }

        },

        //学科--柱状图
        async GetTeacherDiscipline () {

            this.chartGetTeacherDiscipline = this.echarts.init(this.$refs.getTeacherDiscipline);
            let self = this;
            let option = {
                //color: ['#3398DB'],
                title: {
                    text: '学科教师分布'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            return self.formatterEllipsis(value);
                        }
                    },
                },
                yAxis: [
                    {
                        minInterval: 1,
                        type: 'value'
                    }
                ],
                series: [{
                    name: '男',
                    type: 'bar',
                    stack: '总量',
                    label: {
                        //normal: {
                        //    show: true,
                        //    position: 'insideRight'
                        //}
                    },
                    data: []
                }, {
                    name: '女',
                    type: 'bar',
                    stack: '总量',
                    label: {
                        //normal: {
                        //    show: true,
                        //    position: 'insideRight'
                        //}
                    },
                    data: []
                },
                ]
            };

            this.chartGetTeacherDiscipline.setOption(option);
            this.chartGetTeacherDiscipline.showLoading();
            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetTeacherDiscipline'
            );
            // xy.http.get(xy.string.format(this.apiPath + 'GetTeacherDiscipline'), null, function (res) {
                if (res&&res.success) {

                    let xAxisDataList = [];

                    let sexFalseList = [];
                    let sexTrueList = [];

                   res.data.forEach( (item)=> {

                        //如果没有此年级,添加
                        if (xAxisDataList.indexOf(item.DisciplineName) < 0) {
                            xAxisDataList.push(item.DisciplineName);
                        }
                        if (item.SexName === "男") {
                            sexTrueList.push(item.Count);
                        } else {
                            sexFalseList.push(item.Count);
                        }

                    });

                    option.xAxis.data = xAxisDataList;
                    option.series[0].data = sexTrueList;
                    option.series[1].data = sexFalseList;

                    this.chartGetTeacherDiscipline.hideLoading();
                    this.chartGetTeacherDiscipline.setOption(option, true);

                } else {
                  this.xy.msgError(res.msg);
                    // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
                }
            // })

        },


        //年龄--柱状图
        async GetAge () {

            this.chartGetAge = this.echarts.init(this.$refs.getAge);

            let option = {
                //color: ['#3398DB'],
                title: {
                    text: '教师年龄分布'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                yAxis: [
                    {
                        minInterval: 1,
                        type: 'value'
                    }
                ],
                series: [{
                    name: '年龄分布',
                    type: 'bar',
                    barWidth: '60%',
                    data: []
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            this.chartGetAge.setOption(option);
            this.chartGetAge.showLoading();
            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetAge'
            );
            // xy.http.get(xy.string.format(this.apiPath + 'GetAge'), null, function (res) {
                if (res&&res.success) {

                    let xAxisDataList = [];
                    let seriesDataList = [];
                    res.data.forEach( (item)=>  {
                        xAxisDataList.push(item.AgeName);
                        seriesDataList.push(item.Count);
                    });

                    option.xAxis.data = xAxisDataList;
                    option.series[0].data = seriesDataList;

                    this.chartGetAge.hideLoading();
                    this.chartGetAge.setOption(option, true);

                } else {
                  this.xy.msgError(res.msg);
                    // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
                }
            // })

        },
        //文本的格式化
        //显示前N个字符+省略号格式
        //{"参数1":"要格式化的文本","参数2":"显示文本的前N个长度"}
        //例： xy.echarts.formatter("1234567890",5)/*==*/"12345..."
        formatterEllipsis: function () {
            let value = "";
            let maxLength = 3;//每项显示文字个数
            if (arguments.length === 1) {
                value = arguments[0];
            } else if (arguments.length === 2) {
                value = arguments[0];
                maxLength = arguments[1];
            } else {
                return "";
            }

            // let ret = "";//拼接加\n返回的类目项
            let valLength = value.length;//X轴类目项的文字个数
            let rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
            if (rowN > 1)//如果类目项的文字大于3,
            {
                return value.substring(0, maxLength) + "...";
            }
            else {
                return value;
            }
        },
  }
};
</script>
<style lang='less' >
// #DaTeacher {
  
// }
</style>

